// Shared address text formatting, used by both address-form.js (form save /
// confirmWithData) and address-book.js (attaching a picked-existing address
// directly, with no address-form in the chain).

export function formatAddress({ firstName, lastName, addressLine1, addressLine2, addressLine3, city, postcode }) {
  return [
    [firstName, lastName].filter(Boolean).join(' '),
    addressLine1,
    addressLine2,
    addressLine3,
    city,
    postcode,
  ].filter(s => s && s.trim()).join('\n');
}

export function formatAddressOneLine({ addressLine1, addressLine2, addressLine3, city, postcode }) {
  return [addressLine1, addressLine2, addressLine3, city, postcode]
    .filter(s => s && s.trim())
    .join(', ');
}